import React from 'react';
import { Link } from 'react-router-dom';
import AUX from '../../../hoc/Aux_';

const RegisterSuccess = () => {
  return (
    <AUX>
      <div
        className="accountbg"
        style={{
          background: "url('assets/images/stardust.png')",
          backgroundSize: 'cover',
        }}
      ></div>
      <div className="wrapper-page">
        <div className="card">
          <div className="card-body">
            <div className="p-3">
              <div className="text-center">
                <i
                  className="mdi mdi-check-circle-outline text-success"
                  style={{ fontSize: '70px' }}
                ></i>
                <h3 className="font-30 text-success">
                  Registration Successful!
                </h3>
              </div>

              <div className="text-center m-t-20">
                <p className="text-muted font-16">
                  Thank you for registering with Web Tracker.
                </p>
                <p className="text-muted font-16">
                  Your account has been created successfully. Please login with
                  the app to start tracking your activity.
                </p>
              </div>

              <div className="form-group row m-t-30">
                <div className="col-12">
                  <Link
                    to="/"
                    className="btn btn-primary w-md col-12 waves-effect waves-light"
                  >
                    Go to Login
                  </Link>
                </div>
              </div>

              <div className="m-t-40 text-center">
                <p className="text-dark">
                  © {new Date().getFullYear() - 1} - {new Date().getFullYear()}{' '}
                  Web Tracker
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default RegisterSuccess;
